import createProductLayout from '../../main-layout/createProductLayout';
import Body from '../../main-layout/body/Body';
import ButtonContainer from '../../main-layout/cta-components/ButtonContainer';
import SmallCardReadMore from './SmallCardReadMore';
import SmallCardHeader from './header/SmallCardHeader';
import { smallCardGrid } from './styles';
export { smallCardGrid };
const SmallCardLayout = createProductLayout({
  coreComponents: {
    Header: SmallCardHeader,
    Body,
    ReadMore: SmallCardReadMore,
    Cta: ButtonContainer
  },
  defaultGrid: smallCardGrid,
  mouseFlowTag: 'Small card'
});
export default SmallCardLayout;
//# sourceMappingURL=SmallCardLayout.js.map